export const ANIMAL_ORDER = [
  "Rat", "Ox", "Tiger", "Rabbit", "Dragon", "Snake",
  "Horse", "Goat", "Monkey", "Rooster", "Dog", "Pig",
];

const LIU_CHONG_PAIRS = [
  [0, 6], [1, 7], [2, 8], [3, 9], [4, 10], [5, 11],
];

const LIU_HE_PAIRS = [
  [0, 1], [2, 11], [3, 10], [4, 9], [5, 8], [6, 7],
];

const SAN_HE_GROUPS = [
  [0, 4, 8],
  [1, 5, 9],
  [2, 6, 10],
  [3, 7, 11],
];

const ELEMENT_ORDER = ["Wood", "Fire", "Earth", "Metal", "Water"];

const FOCUS_AREAS = ["relationships", "career", "wellness", "growth"];

export function animalIndex(name) {
  const idx = ANIMAL_ORDER.indexOf(name);
  return idx >= 0 ? idx : 0;
}

function pairKey(a, b) {
  return a < b ? `${a}:${b}` : `${b}:${a}`;
}

function buildPairSet(pairs) {
  return new Set(pairs.map(([a, b]) => pairKey(a, b)));
}

const LIU_CHONG_SET = buildPairSet(LIU_CHONG_PAIRS);
const LIU_HE_SET = buildPairSet(LIU_HE_PAIRS);

function sanHeGroupFor(index) {
  return SAN_HE_GROUPS.find((group) => group.includes(index)) || null;
}

export function computeBranchRelation(birthAnimal, readingAnimal) {
  const birthIdx = animalIndex(birthAnimal);
  const readingIdx = animalIndex(readingAnimal);

  if (birthIdx === readingIdx) return "same";

  if (LIU_CHONG_SET.has(pairKey(birthIdx, readingIdx))) return "liu_chong";

  if (LIU_HE_SET.has(pairKey(birthIdx, readingIdx))) return "liu_he";

  const birthGroup = sanHeGroupFor(birthIdx);
  if (birthGroup && birthGroup.includes(readingIdx)) return "san_he";

  return "neutral";
}

export function computeElementRelation(dayElement, birthElement) {
  const dayIdx = ELEMENT_ORDER.indexOf(dayElement);
  const birthIdx = ELEMENT_ORDER.indexOf(birthElement);
  if (dayIdx < 0 || birthIdx < 0) return "neutral";
  if (dayIdx === birthIdx) return "same";

  const generatesBirth = (dayIdx + 1) % 5 === birthIdx;
  const birthGeneratesDay = (birthIdx + 1) % 5 === dayIdx;
  const dayOvercomesBirth = (dayIdx + 2) % 5 === birthIdx;
  const birthOvercomesDay = (birthIdx + 2) % 5 === dayIdx;

  if (generatesBirth) return "generates";
  if (birthGeneratesDay) return "generated_by";
  if (dayOvercomesBirth) return "overcomes";
  if (birthOvercomesDay) return "overcome_by";

  return "neutral";
}

export function pickDailyFocusArea(seed) {
  return FOCUS_AREAS[Math.abs(seed) % FOCUS_AREAS.length];
}

export function hashSectionSeed(dateSeed, chartSeed, sectionName) {
  const raw = `${dateSeed}:${chartSeed}:${sectionName}`;
  let hash = 0;
  for (let i = 0; i < raw.length; i += 1) {
    hash = ((hash << 5) - hash) + raw.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export function sectionVariantIndex(dateSeed, chartSeed, sectionName, variantCount) {
  return hashSectionSeed(dateSeed, chartSeed, sectionName) % variantCount;
}
